import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { LocalStorageService } from 'lib/utils'
import { AUTH_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class AuthService {
  static getSubdivisions = async branchCode => {
    if (!branchCode) {
      return null
    }

    try {
      const data = {
        branchCode: typeof branchCode === 'object' ? branchCode.code : branchCode
      }

      const result = await HTTPHandler.post(AUTH_API_URL + '/dictionary/subdivisions', data)

      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static login = async data => {
    try {
      const result = await HTTPHandler.post(AUTH_API_URL + '/authenticate', data)
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getUserByToken = async () => {
    try {
      const result = await HTTPHandler.get(AUTH_API_URL + '/users/getUserByToken')
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getUsers = async (data = {}) => {
    try {
      const result = await HTTPHandler.post(AUTH_API_URL + '/users/getUsers', {
        isActive: true,
        limit: 1000,
        offset: 0,
        ...data
      })
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getBranches = async () => {
    try {
      const result = await HTTPHandler.get(AUTH_API_URL + '/branches')
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static getUsersByRole = async (role = '', project = '') => {
    try {
      const result = await HTTPHandler.get(
        AUTH_API_URL + `/users/getUsersByRole?roleCode=${role}&projectCode=${project}`
      )
      return formatResponse(result)
    } catch (e) {
      return createError(e)
    }
  }

  static setToken = token => {
    if (!!token) {
      LocalStorageService.setAccessToken(token)
      HTTPHandler.api.defaults.headers.Authorization = `Bearer ${token}`
    } else {
      LocalStorageService.removeAccessToken()
      delete HTTPHandler.api.defaults.headers.Authorization
    }
  }
}
